import { Link } from "@inertiajs/react"
import { ArrowUpRight } from "lucide-react"

interface SidebarSwitchButtonProps {
  href: string
  children: string
}

export function SidebarSwitchButton({
  href,
  children,
}: SidebarSwitchButtonProps) {
  return (
    <Link
      href={href}
      className="relative z-10 inline-flex h-8 w-full items-center justify-center gap-1.5 rounded-md border border-[#567c5d] bg-[#396642] text-sm font-medium text-[#dfffe5] transition-colors group-data-[collapsible=icon]:size-8 group-data-[collapsible=icon]:p-0 hover:border-[#6d9874] hover:bg-[#457a4e] hover:text-white focus-visible:ring-2 focus-visible:ring-[#6d9874]/70 focus-visible:outline-none active:bg-[#2f5638]"
    >
      <span className="group-data-[collapsible=icon]:sr-only">{children}</span>
      <ArrowUpRight className="hidden size-4 group-data-[collapsible=icon]:block" />
    </Link>
  )
}
